<template>
  <div class="widget widget-text" :data-field="fieldName" :id="fieldName">
    <input :class="['form-control form-control-sm', autoWidth ? 'auto-width' : '']" type="text" v-model="value" v-on:keyup="onChange" :disabled="!editable" :readonly="readOnly && editable">
  </div>
</template>

<script>
export default {
  name: 'text-widget',

  props: {
    fieldIndex: {
      type: String,
      required: true
    },
    initialValue: {
      type: String,
      required: true
    },
    editable: {
      type: Boolean,
      default: true
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    autoWidth: {
      type: Boolean,
      default: false
    },
    model: {
      type: String,
      default: ''
    },
    fieldName: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      value: '',
      keyUpTimeout: null
    }
  },

  mounted () {
    this.value = this.initialValue
    let that = this
    this.$on('setValue', function (val) {
      that.value = val
    })
  },

  methods: {
    onChange (e) {
      if (this.readOnly || !this.editable) return
      if (this.keyUpTimeout !== null) window.clearTimeout(this.keyUpTimeout)
      this.keyUpTimeout = window.setTimeout(this.emitChange, 500)
    },

    emitChange (e) {
      window.clearTimeout(this.keyUpTimeout)
      this.keyUpTimeout = null
      this.$parent.$emit('widgetChanged', {index: this.fieldIndex, value: this.value})
    }
  },

  beforeDestroy () {
    this.$off('setValue')
  }
}
</script>

<style lang="scss" scoped>
  .form-control[readonly] {
    background-color: #FFF !important;
    cursor: default;
    z-index: 1;

    &:focus {
      box-shadow: inherit;
      border-color: rgb(206, 212, 218);
    }
  }

  .auto-width {
    width: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/questionnaires/widgets/TextWidget.vue